import { ButtonC } from "Common/Buttons";
import InputC from "Common/Inputs/index.tsx";
import { useEffect, useRef, useState } from "react";

const ConfigButton = ({ headerData, setSelectedFields, disabled }) => {
  const [visible, setVisible] = useState(false);
  const configRef = useRef(null);

  // normalize id (supports both value & key)
  const getFieldId = (field) => field?.value ?? field?.key;

  // toggle checkbox
  const toggleField = (id) => {
    setSelectedFields((prev) =>
      prev.map((field) => {
        const fieldId = getFieldId(field);
        return fieldId === id
          ? { ...field, checked: !field.checked }
          : field;
      })
    );
  };

  // reset to defaults
  const resetFields = () => {
    const defaultKeys = ["formName", "createdA"];

    setSelectedFields((prev) =>
      prev.map((field) => {
        const fieldId = getFieldId(field);
        return {
          ...field,
          checked: defaultKeys.includes(fieldId),
        };
      })
    );
  };

  // close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (configRef.current && !configRef.current.contains(event.target)) {
        setVisible(false);
      }
    };

    if (visible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visible]);

  return (
    <div style={{ position: "relative" }}>
      <ButtonC
        disabled={disabled}
        size="lg"
        color="Primary"
        className="btn btn-dark"
        click={() => setVisible((v) => !v)}
      >
        Configure View
      </ButtonC>

      {visible && (
        <div
          ref={configRef}
          className="position-absolute top-100 end-0 mt-2 p-3 rounded shadow"
          style={{
            width: 250,
            zIndex: 100,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
          }}
        >
          <div className="fw-bold mb-2">Configure the view</div>

          <div className="d-flex justify-content-between mb-2">
            <span className="small">Displayed fields</span>
            {/* <button
              className="btn btn-link btn-sm text-muted p-0"
              onClick={resetFields}
            >
              Reset
            </button> */}
          </div>

          <div
            style={{ maxHeight: 200, overflowY: "auto" }}
            className="custom-scrollbar"
          >
            {headerData.map((field) => {
              const fieldId = getFieldId(field);

              return (
                <div key={fieldId} className="form-check mb-1">
                  <InputC
                    size="sm"
                    type="Checkbox"
                    inputvalue={!!field.checked}
                    label={field.title || "Actions"}
                    change={() => toggleField(fieldId)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigButton;
